import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "other-games.icon",
  "use": "other-games.icon-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 25 25\" id=\"other-games.icon\">\n    <path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M3 4a2 2 0 104 0 2 2 0 00-4 0zm8 15a6 6 0 100-12 6 6 0 000 12zm-8 3a3 3 0 100-6 3 3 0 000 6zm18 0a4 4 0 110-8 4 4 0 010 8zm-7 2a2 2 0 110-4 2 2 0 010 4zm5-17a2 2 0 104 0 2 2 0 00-4 0zM2 12a1 1 0 110-2 1 1 0 010 2zm11-8a1 1 0 102 0 1 1 0 00-2 0z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol